let view = null;

export default {
	namespace: 'template-services',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ServicesView } = await import(
			/* webpackChunkName: "services-view" */ '../../templates/ServicesView'
		);
		view = new ServicesView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
